/* GGS CART v2 - 2026-09-24. Behaviour for sections/main-cart-items.liquid.
   Every cart change goes to Shopify's AJAX API with this section in the
   `sections` parameter; the re-rendered HTML then replaces only the
   [data-ggc-live] regions and the shipping fill. The form, the order note and
   the dynamic checkout buttons are never re-rendered. Crossing between an
   empty and a non-empty cart reloads the page, because the checkout button
   and the dynamic checkout buttons only render server-side. */
(function () {
  'use strict';
  var root = document.querySelector('[data-ggc]');
  if (!root) return;

  var sectionId = root.getAttribute('data-section');
  var swap = root.querySelector('[data-ggc-swap]');
  var stage = root.querySelector('[data-ggc-stage]');
  var img = root.querySelector('[data-ggc-img]');
  var sNum = root.querySelector('[data-ggc-num]');
  var sScent = root.querySelector('[data-ggc-scent]');
  var sName = root.querySelector('[data-ggc-name]');
  var sPrice = root.querySelector('[data-ggc-price]');
  var errEl = root.querySelector('[data-ggc-err]');
  var statusEl = root.querySelector('[data-ggc-status]');
  var busy = false;

  /* ---- header offset: pull the split screen up under the fixed header ---- */
  function setHeaderOffset() {
    var h = document.querySelector('.shopify-section-group-header-group');
    if (h) root.style.setProperty('--ggc-hdr', Math.round(h.getBoundingClientRect().height) + 'px');
  }
  setHeaderOffset();
  window.addEventListener('resize', setHeaderOffset);

  /* ---- reveal fallback: never leave a panel element stuck at opacity 0 ---- */
  function settle() {
    root.querySelectorAll('.ggc-reveal:not(.is-in)').forEach(function (el) {
      if (el._ggcSettle) return;
      el._ggcSettle = true;
      el.addEventListener('animationend', function () { el.classList.add('is-in'); }, { once: true });
      var d = parseFloat(getComputedStyle(el).animationDelay) * 1000 || 0;
      setTimeout(function () { el.classList.add('is-in'); }, 900 + d);
    });
  }
  settle();

  /* ---- stage ---- */
  var cur = img ? img.getAttribute('src') : '';
  var preloaded = {};
  function preload(src) {
    if (!src || preloaded[src]) return;
    preloaded[src] = true;
    var i = new Image();
    i.src = src;
  }
  root.querySelectorAll('[data-stage]').forEach(function (el) { preload(el.getAttribute('data-img')); });

  var swapTimer = null;
  function showStage(el) {
    if (!el || !img) return;
    var src = el.getAttribute('data-img');
    if (!src || src === cur) return;
    cur = src;
    swap.classList.add('is-swapping');
    clearTimeout(swapTimer);
    swapTimer = setTimeout(function () {
      img.src = src;
      img.alt = el.getAttribute('data-name') || '';
      sNum.textContent = el.getAttribute('data-num') || '';
      sScent.textContent = el.getAttribute('data-scent') || '';
      sName.textContent = el.getAttribute('data-name') || '';
      sPrice.textContent = el.getAttribute('data-price') || '';
      swap.classList.remove('is-swapping');
    }, 260);
  }

  root.addEventListener('mouseover', function (e) {
    var t = e.target.closest && e.target.closest('[data-stage]');
    if (t && root.contains(t)) showStage(t);
  });
  root.addEventListener('focusin', function (e) {
    var t = e.target.closest && e.target.closest('[data-stage]');
    if (t) showStage(t);
  });

  if (stage) {
    stage.addEventListener('pointermove', function (e) {
      var r = stage.getBoundingClientRect();
      var dx = Math.max(-1, Math.min(1, (e.clientX - (r.left + r.width / 2)) / (r.width / 2)));
      var dy = Math.max(-1, Math.min(1, (e.clientY - (r.top + r.height / 2)) / (r.height / 2)));
      stage.style.setProperty('--px', dx * 24 + 'px');
      stage.style.setProperty('--py', dy * 18 + 'px');
    });
    stage.addEventListener('pointerleave', function () {
      stage.style.setProperty('--px', '0px');
      stage.style.setProperty('--py', '0px');
    });
  }

  /* ---- helpers ---- */
  function showError(msg) {
    if (!errEl) return;
    errEl.textContent = msg || '';
    errEl.hidden = !msg;
  }
  function bump(el) {
    if (!el) return;
    el.classList.remove('ggc-bump');
    void el.offsetWidth;
    el.classList.add('ggc-bump');
  }
  function headerCount(n) {
    /* Bag icon, 2026-09-30: update only the count spans. Rewriting a link's
       textContent strips its child markup (the bag svg), so links that hold a
       count span are left alone; the plain-text fallback below is kept for any
       header that still has a bare "Cart (n)" link. */
    document.querySelectorAll('.shopify-section-group-header-group [data-ggs-cart-count]').forEach(function (s) {
      s.textContent = n;
    });
    document.querySelectorAll('.shopify-section-group-header-group a[href$="/cart"]').forEach(function (a) {
      if (a.querySelector('[data-ggs-cart-count]')) return;
      if (/^\s*Cart\s*\(\d+\)\s*$/.test(a.textContent)) a.textContent = 'Cart (' + n + ')';
    });
  }
  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) throw new Error(j.description || j.message || 'Something went wrong. Please try again.');
        return j;
      });
    });
  }

  /* Apply a re-rendered copy of this section. focusKey keeps the stage and
     keyboard focus on the line that just changed. */
  function apply(html, focusKey) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('[data-ggc]');
    if (!fresh) { location.reload(); return; }

    var newCount = parseInt(fresh.getAttribute('data-count'), 10) || 0;
    var oldCount = parseInt(root.getAttribute('data-count'), 10) || 0;
    if ((newCount === 0) !== (oldCount === 0)) { location.reload(); return; }

    var oldPrices = {};
    root.querySelectorAll('.ggc-row').forEach(function (r) {
      oldPrices[r.getAttribute('data-key')] = r.querySelector('.ggc-row__price').textContent;
    });
    var oldTotal = (root.querySelector('[data-ggc-live="total"]') || {}).textContent;

    fresh.querySelectorAll('[data-ggc-live]').forEach(function (n) {
      var key = n.getAttribute('data-ggc-live');
      var here = root.querySelector('[data-ggc-live="' + key + '"]');
      if (!here) return;
      here.innerHTML = n.innerHTML;
      here.className = n.className.replace(/\bggc-reveal\b/, 'ggc-reveal is-in');
    });

    var nf = fresh.querySelector('[data-ggc-fill]');
    var of = root.querySelector('[data-ggc-fill]');
    if (nf && of) {
      of.className = nf.className;
      of.style.width = nf.style.width;
    }

    root.setAttribute('data-count', newCount);
    headerCount(newCount);

    root.querySelectorAll('.ggc-row').forEach(function (r) {
      var k = r.getAttribute('data-key');
      var p = r.querySelector('.ggc-row__price');
      if (oldPrices[k] !== undefined && oldPrices[k] !== p.textContent) {
        bump(p);
        bump(r.querySelector('.ggc-stepper__out'));
      }
    });
    var t = root.querySelector('[data-ggc-live="total"]');
    if (t && oldTotal !== t.textContent) bump(t);

    root.querySelectorAll('[data-stage]').forEach(function (el) { preload(el.getAttribute('data-img')); });

    if (focusKey) {
      var row = root.querySelector('.ggc-row[data-key="' + focusKey + '"]');
      if (row) showStage(row);
    }
    if (statusEl) statusEl.textContent = (root.querySelector('[data-ggc-live="title"]') || {}).textContent || '';
  }

  function change(line, qty, row) {
    if (busy) return;
    busy = true;
    showError('');
    root.classList.add('is-busy');
    var key = row ? row.getAttribute('data-key') : null;
    var leaving = qty === 0 && row;
    if (row) row.classList.add(leaving ? 'is-leaving' : 'is-busy');
    var wait = new Promise(function (res) { setTimeout(res, leaving ? 350 : 0); });
    var req = post(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/change.js' : '/cart/change.js', {
      line: line,
      quantity: qty,
      sections: [sectionId],
      sections_url: window.location.pathname
    });
    Promise.all([req, wait])
      .then(function (out) {
        var j = out[0];
        if (j.sections && j.sections[sectionId]) {
          apply(j.sections[sectionId], leaving ? null : key);
          if (leaving) showStage(root.querySelector('.ggc-row'));
        } else location.reload();
      })
      .catch(function (e) {
        if (row) row.classList.remove('is-leaving', 'is-busy');
        showError(e.message);
      })
      .finally(function () {
        busy = false;
        root.classList.remove('is-busy');
      });
  }

  function add(variantId, pill) {
    if (busy) return;
    busy = true;
    showError('');
    if (pill) pill.classList.add('is-busy');
    post('/cart/add.js', {
      items: [{ id: parseInt(variantId, 10), quantity: 1 }],
      sections: [sectionId],
      sections_url: window.location.pathname
    })
      .then(function (j) {
        var key = j.items && j.items[0] ? j.items[0].key : null;
        if (j.sections && j.sections[sectionId]) apply(j.sections[sectionId], key);
        else location.reload();
      })
      .catch(function (e) {
        if (pill) pill.classList.remove('is-busy');
        showError(e.message);
      })
      .finally(function () { busy = false; });
  }

  root.addEventListener('click', function (e) {
    var q = e.target.closest('[data-ggc-qty]');
    if (q && root.contains(q)) {
      e.preventDefault();
      var row = q.closest('.ggc-row');
      change(parseInt(row.getAttribute('data-line'), 10), Math.max(0, parseInt(q.getAttribute('data-ggc-qty'), 10)), row);
      return;
    }
    var a = e.target.closest('[data-ggc-add]');
    if (a && root.contains(a)) {
      e.preventDefault();
      showStage(a);
      add(a.getAttribute('data-ggc-add'), a);
    }
  });

  /* order note: saved as the shopper types (debounced), and also submitted
     with the checkout form because the field sits inside it */
  var note = root.querySelector('[data-ggc-note]');
  if (note) {
    var nt = null;
    note.addEventListener('input', function () {
      clearTimeout(nt);
      nt = setTimeout(function () {
        post('/cart/update.js', { note: note.value }).catch(function () {});
      }, 500);
    });
  }
})();
